import { Backdrop, CircularProgress, Box } from "@mui/material";

const LoadingOverlay = ({ isLoading }) => (
    <Box sx={{ position: "relative" }}>
        {isLoading && (
            <Backdrop
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.7)", // Light blur effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px", // Match container styles
                }}
                open={isLoading}
            >
                <CircularProgress color="primary" />
            </Backdrop>
        )}
    </Box>
);

export default LoadingOverlay;